import Divider, { DividerProps } from './Divider';

export type { DividerProps };
export default Divider;
